import './ProcessAlreadyStartedModal.scss';
import React from 'react';
import { ModalComponent } from 'components/modal/modalComponent';
import { isMobile } from 'utilities/browser';
import { TAGGING } from '../constants';
import { LOGIN_DESKTOP, LOGIN_MOBILE, PUBLICA_URL } from 'constants/index';
import { formatText, FormattedText } from 'core/i18n';
import { useContext } from 'react';
import { NewUserRequirementsViewContext } from '../contexts/NewUserRequirementsViewContext';
import { doTagCloseProcessAlreadyStartedModal, doTagProcessRecover } from './tagging';

const handleClickRedirectLogin = () => {
    const toggleLogin = isMobile() ? LOGIN_MOBILE : LOGIN_DESKTOP;
    window.location.assign(`${PUBLICA_URL}${toggleLogin}`);
};

export const ProcessAlreadyStartedModal = () => {
    const { isProcessAlreadyStartedModalOpen, handleToggleProcessAlreadyStartedModal } =
        useContext(NewUserRequirementsViewContext);

    const handleCloseModal = ({ isCross }) => {
        const { CROSS } = TAGGING;

        handleToggleProcessAlreadyStartedModal();
        doTagCloseProcessAlreadyStartedModal(isCross ? CROSS : null);
    };

    const handleConfirmModal = () => {
        handleClickRedirectLogin();
        doTagProcessRecover();
    };

    return (
        <ModalComponent
            className="process-already-started-modal"
            isOpen={isProcessAlreadyStartedModalOpen}
            title={formatText('newUserRequirements-processAlreadyStarted')}
            onCancel={handleCloseModal}
            cancelText={formatText('button-close')}
            onConfirm={handleConfirmModal}
            confirmText={formatText('newUserRequirements-recoverMyProcess')}
            isConfirmDisabled={false}
        >
            <FormattedText value="newUserRequirements-youMustLoginWithYourUser" />
            <FormattedText value="newUserRequirements-forgotAccessCode" />
        </ModalComponent>
    );
};
